import React, { useEffect } from "react";
import  Loading  from '../../components/ui/Loading'
import { useSelector } from "react-redux";
import { useDispatch, } from "react-redux";
import { getSocieties } from "../../Store/Ducks/duckSocieties";
import { getDocumentType } from "../../Store/Ducks/duckDocumentType";
import { getCurrencies } from "../../Store/Ducks/duckCurrencies";
import { getHelpRequestPostGet } from "../../Store/Ducks/masterData/duckMasterData";
import {CountryList} from './CountryList'
import { getReasons } from "../../Store/Ducks/duckReason";
import { getTickets } from '../../Store/Ducks/duckTickets';
import { getSupplierCuit } from "../../Store/Ducks/duckSupplier";
export const SelectCountry = () => {
  const dispatch = useDispatch();
  
  const email = useSelector(store => store.authentication?.authenticatedUser?.email);
  const societies = useSelector(store => store.societies.data);
    useEffect(() => {
      if(email!==undefined){
        dispatch(getTickets(email))
        dispatch(getCurrencies())
        dispatch(getReasons())
        dispatch(getSupplierCuit(email))      
        dispatch(getDocumentType())
        dispatch(getHelpRequestPostGet())
        if(societies.length===0)
          dispatch(getSocieties())
      }      
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [email])
  return (<>
  {
    societies && societies.length>0 ?
    <CountryList societies={societies}/>:
    <Loading />
  }
    
  </>
  );
};